<template>
  <div class="table">
    <div class="tr" v-for="(row, idx) in table.rows" :key="idx">
      <div class="td" v-for="(col, idx) in row" :key="idx">
        <div class="td__title">{{col.name}}</div>
        <div class="td__value td__value--percent" v-if="col.code === 'percent'">{{col.value }}%</div>
        <div class="td__value" v-else>{{valueFormatter(col.value, col.code)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['item'],
    computed: {
      table() {
        return this.$props.item.original_sales_table;
      },
    },
    methods: {
      valueFormatter(value, type) {
        if (type === 'brand') return value;

        return new Intl.NumberFormat('ru-RU', {
          style: 'currency',
          currency: 'RUB',
          maximumFractionDigits: 0,
        }).format(value);
      },
    },
  };
</script>

<style scoped lang="scss">
  .table {
    .tr {
      border: 1px solid #DEE2E6;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
      box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    }
    .th {
      &:last-child {
        border-right: 1px solid #DEE2E6;
      }
    }
    .td {
      border-bottom: 1px solid #DEE2E6;
      display: flex;

      @media (max-width: 576px) {
        flex-direction: column;
      }

      &__title,
      &__value {
        color: #707880;
        font-weight: 500;
        padding: 8px 15px;
      }
      &__title {
        background-color: #f9f9f9;

        @media (min-width: 577px) {
          flex: 0 0 190px;
          border-right: 1px solid #DEE2E6;
          border-bottom: 1px solid white;
        }
      }

      &__value {
        width: 100%;
      }

      &:last-child {
        border: none;
        .td__title {

          @media (min-width: 577px) {
            border-bottom: none;
          }
        }
      }
    }
  }
</style>
